import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/context/auth';
import { SharePointAuthProvider } from './components/AuthProvider';
import Auth from './pages/Auth';
import NotFound from './pages/NotFound';
import Teams from './pages/Teams';
import Settings from './pages/Settings';
import Logs from './pages/Logs';
import PowerBIReport from './pages/PowerBIReport';
import Policies from './pages/Policies';
import PolicyEditor from './pages/PolicyEditor';
import PolicyAutoExecutor from './pages/PolicyAutoExecutor';
import './App.css';
import { useAuth } from '@/context/auth';

const AppRoutes = () => {
  const { user } = useAuth();
  
  const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    if (!user) {
      return <Navigate to="/auth" replace />;
    }
    return <>{children}</>;
  };
  
  const HomeRedirect = () => {
    if (user) {
      return <Navigate to="/teams" replace />;
    }
    return <Navigate to="/auth" replace />;
  };

  return (
    <Routes>
      <Route path="/auth" element={!user ? <Auth /> : <Navigate to="/teams" replace />} />
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/teams" element={<ProtectedRoute><Teams /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/logs" element={<ProtectedRoute><Logs /></ProtectedRoute>} />
      <Route path="/powerbi" element={<ProtectedRoute><PowerBIReport /></ProtectedRoute>} />
      <Route path="/policies" element={<ProtectedRoute><Policies /></ProtectedRoute>} />
      <Route path="/policy-editor" element={<ProtectedRoute><PolicyEditor /></ProtectedRoute>} />
      <Route path="/policy-auto-executor" element={<ProtectedRoute><PolicyAutoExecutor /></ProtectedRoute>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <SharePointAuthProvider>
          <AppRoutes />
        </SharePointAuthProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
